import { gql } from '@apollo/client';
import { AccountInfoShared, ErrorMessageInfo } from '@retainerclub/shared-api';

export default gql`
  mutation actionImportLegacyAccountShell(
    $input: ImportLegacyAccountShellInput!
  ) {
    actionImportLegacyAccountShell(input: $input) {
      clientMutationId
      errorMessages {
        ...ErrorMessageInfo
      }
      success
      account {
        ...AccountInfoShared
      }
      user {
        id
        firstName
        lastName
        email
        phone
        legacyId
      }
      warnings
    }
  }
  ${ErrorMessageInfo}
  ${AccountInfoShared}
`;
